import { LinearGradient } from 'expo-linear-gradient';
import React, { ReactNode } from 'react';
import { View, StyleSheet, Image, ViewStyle, StyleProp } from 'react-native';
import { useMediaQuery } from 'react-responsive';

import Logo from 'shared/assets/images/logo.png';

type Props = {
  style?: StyleProp<ViewStyle>;
  children?: ReactNode;
};

const Background = (props: Props) => {
  const isBigScreen = useMediaQuery({ minWidth: 768 });

  return (
    <LinearGradient
      colors={['#F4F1EB', '#DBD5D1']}
      start={{ x: 0, y: 0 }}
      end={{ x: 1, y: 6 }}
      style={[styles.root, props.style]}
    >
      <Image
        source={{ uri: Logo }}
        style={[styles.logo, { width: isBigScreen ? 110 : 80 }]}
      />
      <LinearGradient
        colors={['#F4F1EB', '#DBD5D1']}
        start={{ x: 0, y: 1 }}
        end={{ x: 1, y: 0 }}
        style={styles.sphereSmall}
      />
      <LinearGradient
        colors={['#F4F1EB', '#DBD5D1']}
        start={{ x: 0, y: 1 }}
        end={{ x: 1, y: 0 }}
        style={styles.sphereLarge}
      />
      <View style={[styles.container, !isBigScreen && { overflow: 'scroll' }]}>
        {props.children}
      </View>
    </LinearGradient>
  );
};

const styles = StyleSheet.create({
  root: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(40, 60, 70, 0.5)',
    overflow: 'hidden',
  },
  container: {
    width: '100%',
    height: '100%',
    overflow: 'hidden',
  },
  logo: {
    position: 'absolute',
    resizeMode: 'contain',
    aspectRatio: 220 / 80,
    marginTop: 24,
    marginLeft: 24,
  },
  sphereLarge: {
    height: 100,
    width: 100,
    borderRadius: 50,
    position: 'absolute',
    left: 121,
    top: 525,
  },
  sphereSmall: {
    height: 33,
    width: 33,
    borderRadius: 15,
    position: 'absolute',
    right: 250,
    top: 216,
  },
});

export default Background;
